import {Injectable} from '@angular/core';
import {first} from 'rxjs/operators';
import {UserService} from './user.service';
import {MessageService} from './message.service';
import {BaseApiService} from '@core/api-services';
import {GameService} from './game.service';

@Injectable({
  providedIn: 'root'
})
export class LogOutService {

  constructor(private userService: UserService,
              private messageService: MessageService,
              private baseApiService: BaseApiService,
              private gameService: GameService) {
  }

  public askLogout(): void {
    // if (this.gameService.gameStarted.value && !this.gameService.gameFinished.value) {
    //   this.openModal();
    // } else {
    this.logout();
    // }
  }

  private logout(): void {
    this.userService.logout();
    // this.gameService.toInitialState();
    this.gameService.cleanStorage();
  }

  private openModal(): void {
    let messageData = {
      msg: 'Are you sure you want to log out?',
      sub_msg: 'Please note the event will end if you leave',
      isConfirm: true
    };
    this.messageService.openConfirmModal(messageData)
      .afterClosed().subscribe((resp: boolean) => {
      if (resp) {
        if (this.gameService.messageSubmitted.value) {
          this.gameService.loading.next(true);
          this.completeStartedEvents();
        } else {
          this.gameService.selectedTabIndex.next(0);
          messageData = {
            msg: 'Please submit your game notes before finishing the event',
            sub_msg: '',
            isConfirm: false
          };
          this.messageService.openConfirmModal(messageData);
        }
      }
    });
  }

  private completeStartedEvents(): void {
    this.baseApiService.gameApiService.completeGame()
      .pipe(first())
      .subscribe(() => {
        this.gameService.loading.next(false);
        this.logout();
      });
  }
}
